module.exports = __webpack_public_path__ + "static/share-facebook-5f39524195e5e3d0b96d1be891a7c690.jpg";